export default __webpack_public_path__ + "static/media/Mark-2-HUD-Dock Icons.2587236c.jpg";